import React from "react";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import nip from "../../../assets/projects/nip.jpg";
import aip from "../../../assets/projects/aip.jpg";

const ColorButton = styled(Button)(() => ({
  color: "#fff",
  width: 180,
  height: 55,
  fontWeight: 700,
  fontSize: "16px",
  textTransform: "capitalize",
  backgroundColor: "#9DCC49",
  borderColor: "#9DCC49",
  "&:hover": {
    color: "#fff",
    backgroundColor: "#317ABE",
    borderColor: "#317ABE",
  },
}));

const Details = () => {
  return (
    <Box>
      <Box
        width={"100%"}
        margin={{ xs: "25% 0%", sm: "5% 0%" }}
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
        flexWrap={"wrap"}
      >
        <Box
          width={{ xs: "100%", sm: "45%" }}
          marginLeft={{ xs: "0%", sm: "0%" }}
        >
          <Typography
            variant="h4"
            color="#317ABE"
            fontWeight={800}
            paddingBottom={"1%"}
            textAlign={"left"}
          >
            Neighbourhood Impact Program (NIP)
          </Typography>
          <Box
            width={{ xs: "100%", sm: "50%" }}
            marginRight={{ xs: "0%", sm: "0%" }}
            display={{ xs: "block", sm: "none" }}
            data-aos={"fade-up"}
          >
            <Box
              component="img"
              height={{ xs: "27vh", sm: "40vh" }}
              width={{ xs: "100%", sm: "100%" }}
              marginTop={{ xs: "8%", sm: "0%" }}
              marginLeft={{ xs: "0%", sm: "0%" }}
              src={nip}
              alt={"Neighbour_Impact_Program"}
              sx={{
                objectFit: "cover",
              }}
            />
          </Box>
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#4f4f4f"}
            paddingTop={"3%"}
            data-aos={"fade-up"}
            lineHeight={"1.625em"}
          >
            The Neighborhood Impact Program is a collaborative project of
            Blue-Echo Foundation and Aquatic Hub Afrique Network and as part of
            our Corporate Social Responsibility to the local communities in
            Abeokuta and other interested communities to ensure a thriving and
            self-sustaining environment.
          </Typography>
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#4f4f4f"}
            paddingTop={"3%"}
            data-aos={"fade-up"}
            lineHeight={"1.625em"}
          >
            The first edition was launched on the 20th of August, 2021 and it
            was a huge success judging by the fact that the communities who took
            part expressed their heartfelt gratitude for being part of the
            program.
          </Typography>
          <Box marginTop={"4%"}>
            <ColorButton
              component={"a"}
              variant="contained"
              size="medium"
              href={"/our-neighbourhood-impact-program"}
            >
              Read More
            </ColorButton>
          </Box>
        </Box>
        <Box
          width={{ xs: "100%", sm: "50%" }}
          marginRight={{ xs: "0%", sm: "0%" }}
          display={{ xs: "none", sm: "block" }}
          data-aos={"fade-up"}
        >
          <Box
            component="img"
            height={{ xs: "4vh", sm: "350px" }}
            width={{ xs: "45%", sm: "100%" }}
            marginTop={{ xs: "8%", sm: "0%" }}
            marginLeft={{ xs: "0%", sm: "0%" }}
            src={nip}
            alt={"Neighbour_Impact_Program"}
            sx={{
              objectFit: "cover",
            }}
          />
        </Box>
      </Box>
      <Box
        width={"100%"}
        margin={{ xs: "25% 0%", sm: "10% 0% 5% 0%" }}
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
        flexWrap={"wrap"}
      >
        <Box
          width={{ xs: "100%", sm: "55%" }}
          marginLeft={{ xs: "0%", sm: "0%" }}
          display={{ xs: "none", sm: "block" }}
          data-aos={"fade-up"}
        >
          <Box
            component="img"
            height={{ xs: "4vh", sm: "380px" }}
            width={{ xs: "45%", sm: "100%" }}
            marginTop={{ xs: "8%", sm: "0%" }}
            marginLeft={{ xs: "0%", sm: "0%" }}
            src={aip}
            alt={"Aquaculture_Intervention_Program"}
            sx={{
              objectFit: "cover",
            }}
          />
        </Box>
        <Box
          width={{ xs: "100%", sm: "40%" }}
          marginLeft={{ xs: "0%", sm: "0%" }}
        >
          <Typography
            variant="h4"
            color="#317ABE"
            fontWeight={800}
            paddingBottom={"1%"}
            textAlign={"left"}
          >
            Aquaculture Intervention Program (AIP)
          </Typography>
          <Box
            width={{ xs: "100%", sm: "55%" }}
            marginLeft={{ xs: "0%", sm: "0%" }}
            display={{ xs: "block", sm: "none" }}
            data-aos={"fade-up"}
          >
            <img
              src={aip}
              alt={"Aquaculture_Intervention_Program"}
              width={"100%"}
              height={"100%"}
            />
          </Box>
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#4f4f4f"}
            data-aos={"fade-up"}
            paddingTop={"3%"}
            lineHeight={"1.625em"}
          >
            A growing industry as the aquaculture needs not just women and
            youths, but also young people who can participate in that growth and
            can engage early in good aquaculture practices.
          </Typography>
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#4f4f4f"}
            paddingTop={"3%"}
            data-aos={"fade-up"}
            lineHeight={"1.625em"}
          >
            Blue-Echo Foundation has begun that journey of inclusion by
            targeting Secondary School students and introducing them to the
            aquaculture industry. An initiative called “Aquaculture Intervention
            Program (AIP)” is being implemented in selected secondary schools
            and will teach students in basic fish farming techniques and pond
            management to empower them with requisite skills in aquaculture.
          </Typography>
          <Box marginTop={"4%"}>
            <ColorButton
              component={"a"}
              variant="contained"
              size="medium"
              href={"/our-aquaculture-intervention-program"}
            >
              Read More
            </ColorButton>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Details;
